import React from 'react';
import { Link } from 'react-router-dom';
// Añadimos Activity a la lista de iconos importados
import { Server, Lock, Gauge, Cloud, Code, TrendingUp, Activity } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: <Server size={32} color="#00FFD1" />,
      title: 'Infraestructura Híbrida',
      description: 'Gestión unificada de servidores on-premise y cloud con un solo panel de control.'
    },
    {
      icon: <Lock size={32} color="#00FFD1" />,
      title: 'Seguridad Avanzada',
      description: 'Hardening automático basado en estándares CIS y auditorías continuas de seguridad.'
    },
    {
      icon: <Gauge size={32} color="#00FFD1" />,
      title: 'Latencia Ultra Baja',
      description: 'Optimización de kernel Linux en tiempo real usando eBPF para latencia mínima.'
    },
    {
      icon: <Cloud size={32} color="#00FFD1" />,
      title: 'Multi-Cloud',
      description: 'Soporte nativo para AWS, Azure, y Google Cloud Platform sin vendor lock-in.'
    },
    {
      icon: <Code size={32} color="#00FFD1" />,
      title: 'Código Abierto',
      description: 'Basado en tecnologías open-source con scripts y playbooks completamente auditables.'
    },
    {
      icon: <TrendingUp size={32} color="#00FFD1" />,
      title: 'Escalabilidad',
      description: 'Diseñado para crecer con tu negocio, desde startups hasta empresas enterprise.'
    },
    {
      // Cambiamos TrendingUp por Activity para Servidores Odoo SAP B1 y Microsip
      icon: <Activity size={32} color="#00FFD1" />,
      title: 'Infraestructura  ERP',
      description: 'Despliegue y optimización de sistemas críticos (Odoo, SAP B1, Microsip) con disponibilidad garantizada.',
      link: '/erp'
    }
  ];

  return (
    <section id="features" style={{
      padding: '100px 7.6923%',
      background: '#000000',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '80px'
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            borderRadius: '0px',
            marginBottom: '24px'
          }}>
            <span style={{
              color: '#00FFD1',
              fontSize: '14px',
              fontWeight: 500
            }}>CARACTERÍSTICAS TÉCNICAS</span>
          </div>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 600,
            lineHeight: 1.1,
            color: '#FFFFFF',
            marginBottom: '20px'
          }}>
            Tecnología de Vanguardia
          </h2>
          <p style={{
            fontSize: '20px',
            color: 'rgba(255, 255, 255, 0.85)',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            Características técnicas diseñadas para PYMES y empresas modernas
          </p>
        </div>

        {/* Features Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '40px'
        }} className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="dark-transition"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '32px',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.4s ease-in-out',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(0, 255, 209, 0.05)';
                e.currentTarget.style.borderColor = 'rgba(0, 255, 209, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              <div>{feature.icon}</div>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#FFFFFF',
                margin: 0
              }}>
                {feature.title}
              </h3>
              <p style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.85)',
                lineHeight: 1.5,
                margin: 0
              }}>
                {feature.description}
              </p>
              {feature.link && (
                <div style={{ marginTop: 'auto', paddingTop: '16px' }}>
                  <Link
                    to={feature.link}
                    style={{
                      display: 'inline-block',
                      padding: '8px 16px',
                      background: 'rgba(0, 255, 209, 0.1)',
                      color: '#00FFD1',
                      border: '1px solid rgba(0, 255, 209, 0.3)',
                      borderRadius: '4px',
                      textDecoration: 'none',
                      fontWeight: 500,
                      fontSize: '14px',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(0, 255, 209, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(0, 255, 209, 0.1)';
                    }}
                  >
                    Saber más
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <style jsx="true">{`
        @media (max-width: 1024px) {
          .features-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)) !important;
          }
        }
        @media (max-width: 767px) {
          .features-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default FeaturesSection;

